export default {
    book_now: 'Prenota ora',
    minimum_age: 'Solo oltre i {age} anni',
    excess_liability: 'Franchigia danni',
    security_deposit: 'Deposito cauzionale',
    fuel_policy: 'Politica del carburante',
    like_for_like: 'Like for Like',
    full_to_full: 'Full to Full',
    miles_per_rental: '{mileage} miglia gratuiti per noleggio',
    km_per_rental: '{mileage} km gratuiti per noleggio',
    unlimited_mileage: 'Miglia illimitati',
    unlimited_mileage_km: 'Km illimitati',
    non_amendable: 'Non modificabile',
    non_refundable: 'Non rimborsabile',
    free_cancellation_until: 'Cancellazione gratuita fino al',
    cancellation_in_line_with: 'Cancellazione in linea con',
    tcs: 'Termini e Condizioni',
    free_extras_on_collection: 'Due extra gratuiti al ritiro',
    glass_and_tyres_covered: 'Copertura vetri e gomme',
    number_of_passengers: 'Numero di passeggeri',
    number_of_bags: 'Numero di bagagli',
    fuel_type: 'Tipo di carburante',
    co2: 'CO2',
    aircon: 'Aria condizionata',
    transmission: 'Trasmissione',
    book_type: 'Prenota {type}',
    debit_card_deposit: 'Carta di debito accettata per i depositi',
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/it/quotes/price_card.js